/**
 * OnboardingGuard - Redirects to dashboard if onboarding is already completed
 *
 * Wraps onboarding pages (except welcome) to prevent access after completion.
 */

import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { readOnboardingCompletionFlag } from "../hooks/useOnboardingCompletionFlag";

interface OnboardingGuardProps {
  children: React.ReactNode;
}

export const OnboardingGuard: React.FC<OnboardingGuardProps> = ({
  children,
}) => {
  const { onboardingCompleted } = useAuth();

  const justCompletedOnboarding = readOnboardingCompletionFlag();

  if (onboardingCompleted || justCompletedOnboarding) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
